"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsNull_1 = __importDefault(require("../typeAssertions/valueIsNull"));
const valueIsNumber_1 = __importDefault(require("../typeAssertions/valueIsNumber"));
const valueIsRecord_1 = __importDefault(require("../typeAssertions/valueIsRecord"));
const valueIsString_1 = __importDefault(require("../typeAssertions/valueIsString"));
const valueIsUndefined_1 = __importDefault(require("../typeAssertions/valueIsUndefined"));
const ensureCorrectProcessorUserInfo = ({ name, email, phone, photoURL, customData, }) => {
    const getBaseValidationError = (base) => `When extracting user info from firebase ref, ${base}`;
    if (!(0, valueIsString_1.default)(name) && !(0, valueIsNull_1.default)(name)) {
        throw new Error(getBaseValidationError('The name should always be an string or null'));
    }
    if (!(0, valueIsString_1.default)(email) && !(0, valueIsNull_1.default)(email) && !(0, valueIsUndefined_1.default)(email)) {
        throw new Error(getBaseValidationError('The email should always be an string or null'));
    }
    if (!(0, valueIsString_1.default)(phone)
        && !(0, valueIsNumber_1.default)(phone)
        && !(0, valueIsNull_1.default)(phone)
        && !(0, valueIsUndefined_1.default)(phone)) {
        throw new Error(getBaseValidationError('The phone should always be an string, number or null'));
    }
    if (!(0, valueIsString_1.default)(photoURL) && !(0, valueIsNull_1.default)(photoURL) && !(0, valueIsUndefined_1.default)(photoURL)) {
        throw new Error(getBaseValidationError('The photo url should always be an string or null'));
    }
    if (!(0, valueIsNull_1.default)(customData) && !(0, valueIsRecord_1.default)(customData) && !(0, valueIsUndefined_1.default)(customData)) {
        throw new Error(getBaseValidationError('The custom data should always be a record or null'));
    }
    return {
        name,
        email,
        phone,
        photoURL,
        customData: customData || undefined,
    };
};
exports.default = ensureCorrectProcessorUserInfo;
